import React, { useState, useEffect } from 'react';
// import styles from './AdvancedEngineeringControls.module.scss';
import styles from '../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import AdvancedNoFilterOptions from '../AdvancedNoFilterOptions/AdvancedNoFilterOptions';
import AdvancedEngineeringRCRA from './AdvancedEngineeringRCRA/AdvancedEngineeringRCRA';

const AdvancedEngineeringControls = (props) => {
  /* since there is only one leaf component to this subcomponent, we can skip
    a lot of the processes the other advanced categories requires */
  const [rcraParams, setrcraParams] = useState<Array<string>>([]);

  const updateRCRAParams = (paramArray) => {
    setrcraParams(paramArray);
  }

  const updateAllEngineeringParams = () => {
    // can pass object ids right to the parent component
    props.updateEngineeringParams(rcraParams);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { updateAllEngineeringParams(); }, [rcraParams]);

  useEffect(() => { }, [props.signalClear]);

  return (
    <div className={styles.SectionContainers}>
      <div className={styles.QuarterSections}>
        <AdvancedNoFilterOptions />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedEngineeringRCRA sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateRCRAParams={updateRCRAParams} />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedNoFilterOptions />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedNoFilterOptions />
      </div>
    </div>
  );
}
export default AdvancedEngineeringControls;
